import BaseEditorExtensionService from '@src/slide/application/service/edit-extension/core/editor/base';
import {
    IPcEditorExtensionService, IPcEditorExtensionServiceDelegates,
} from '@src/slide/application/service/edit-extension/core/editor/pc/interface';

export default class PcEditorExtensionService extends BaseEditorExtensionService
    implements IPcEditorExtensionService {
    declare protected services: IPcEditorExtensionServiceDelegates;
    /**
     * 显示修订记录侧边栏
     * @param config
     */
    public showHistoryRightBar(config?: { activeId: string; showTab?: boolean }): void {
        this.services.historyManager?.show(config);
    }

    /**
     * 监听编辑类型（母版编辑/幻灯片编辑）变化
     */
    public watchEditTypeChange(callback: (editType: string) => void) {
        this.services.masterLayoutEditService?.watchEditTypeChange((editType: string) => callback?.(editType));
    }
}
